document.addEventListener("DOMContentLoaded", function() {
  if (!localStorage.getItem('ageVerified')) {
    document.getElementById('age-verification-popup').style.display = 'flex';
  }
  document.getElementById('age-yes').addEventListener('click', function() {
    localStorage.setItem('ageVerified', 'true');
    document.getElementById('age-verification-popup').style.display = 'none';
  });
  document.getElementById('age-no').addEventListener('click', function() {
    window.location.href = 'https://www.google.com';  
  });
});
